import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getDigitalizationAndAutomationPath } from "@core/schema/paths/getDigitalizationAndAutomationPath.js";
import { getEcommercePath } from "@core/schema/paths/getEcommercePath.js";
import { getKiosksPath } from "@core/schema/paths/getKiosksPath.js";
import { getProjectRescuePath } from "@core/schema/paths/getProjectRescuePath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";

export function getFaqsClients(tenant: Tenant): Faq[] {
	return [
		{
			question: "Pro která odvětví připravujete IT řešení na míru?",
			answer: `Máme zkušenosti s vývojem a dalšími IT řešeními například pro [${getEcommercePath(tenant)}][[e-commerce,]] logistiku, výrobu, účetnictví nebo automotive. Pomáhali jsme klientům i z řady dalších odvětví a zorientujeme se i v tom vašem.`,
		},
		{
			question: "S čím vším nám dokážete pomoci?",
			answer: `Rádi pro vás zajistíme mimo jiné vývoj [${getWebAppsPath(tenant)}][[webových]] či mobilních aplikací na míru, [${getProjectRescuePath(tenant)}][[záchranu projektu]], [${getKiosksPath(tenant)}][[kioskové řešení]] nebo [${getDigitalizationAndAutomationPath(tenant)}][[řešení pro digitalizaci firmy]].`,
		},
		{
			question: "Jaký je postup na začátku spolupráce?",
			answer:
				"Po podpisu NDA a smlouvy o rámcovém vývoji se ponoříme do analýzy vašeho podnikání. Je pro nás důležité, abychom porozuměli vašemu byznysu a cílům. Díky tomu vám zvládneme připravit řešení na míru.",
		},
	];
}
